import { atom } from 'jotai'

// The theme id assigned to the story currently being played (story.options.theme).
// Set when a play session/story loads, cleared on exit so the lobby/profile stay
// on the default theme. Plain atom — it's session-scoped, not persisted.
export const activeStoryThemeAtom = atom(null)

// Public admin-authored custom themes, keyed by id (or slug). Populated from
// GET /api/themes in Phase E; empty until then, which the resolver handles by
// falling back to Novastar for any unknown id.
export const customThemesAtom = atom({})
